import { $axios, apiList } from '@/api'


export default {
    actions: {
        getModInExamus(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.examus2.getModInExamus.method,
                    params: {
                        wsfunction: apiList.examus2.getModInExamus.moodle_method,
                        cmid: payload['cmid'],
                        modname: payload['modname']
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }

}
